import MiddlewareEntities from "./MiddlewareEntities";

export const ActionTypes = {
  INIT: 'INIT',
  SET_LOADER: '[UI] SET_LOADER',
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',
  API_REQUEST: 'API_REQUEST',
  API_SUCCESS: 'API_SUCCESS',
  API_ERROR: 'API_ERROR',
  MAINTENANCE_SET: 'MAINTENANCE_SET',
  NOT_FOUND: 'NOT_FOUND',
  SET_ERROR_MODE: 'SET_ERROR_MODE',
  SET_ERROR: '[UI] SET_ERROR',
  ENTER_IN_MAINTENANCE_MODE: 'ENTER_IN_MAINTENANCE_MODE',
  SET_API_RESPONSE_IN_CACHE: 'SET_API_RESPONSE_IN_CACHE',
  SET_CAPTCHA_REQUIRED: 'SET_CAPTCHA_REQUIRED',
  SET_ITEM_IN_LOCAL_STORAGE: 'SET_ITEM_IN_LOCAL_STORAGE',
  GET_ITEM_FROM_LOCAL_STORAGE: 'GET_ITEM_FROM_LOCAL_STORAGE',
  PRODUCTS: {
    FETCH: `${MiddlewareEntities.PRODUCTS} FETCH`,
    SET: `${MiddlewareEntities.PRODUCTS} SET`,
    ENRICH: `${MiddlewareEntities.PRODUCTS} ENRICH`,
    SET_FILTERED: `${MiddlewareEntities.PRODUCTS} SET_FILTERED`,
    SET_SEARCHED: `${MiddlewareEntities.PRODUCTS} SET_SEARCHED`,
  },
  SCROLL: {
    SET_POSITION: "SET_POSITION",
  },
  PRODUCT: {
    FETCH: `${MiddlewareEntities.PRODUCT} FETCH`,
    SET: `${MiddlewareEntities.PRODUCT} SET`,
    ENRICH: `${MiddlewareEntities.PRODUCT} ENRICH`,
    PRODUCT_DATA: {
      GET_PRODUCT_DATA: `${MiddlewareEntities.PRODUCT} GET_PRODUCT_DATA`,
      SET_PRODUCT_DATA: `${MiddlewareEntities.PRODUCT} SET_PRODUCT_DATA`,
      SET_TP_ID: `${MiddlewareEntities.PRODUCT} SET_TP_ID`,
      SET_COLOR: `${MiddlewareEntities.PRODUCT} SET_COLOR`,
      SET_CONTRACT_OBLIGATION: `${MiddlewareEntities.PRODUCT} SET_CONTRACT_OBLIGATION`,
      SET_COSMOS_INSTALLMENTS: `${MiddlewareEntities.PRODUCT} SET_COSMOS_INSTALLMENTS`,
      SET_PARTICIPATION: `${MiddlewareEntities.PRODUCT} SET_PARTICIPATION`,
      SET_COSMOS_MODEL: `${MiddlewareEntities.PRODUCT} SET_COSMOS_MODEL`,
      SET_PAYMENT_TYPE: `${MiddlewareEntities.PRODUCT} SET_PAYMENT_TYPE`,
      SET_INSTALLMENTS_OVER_BILL_PERIOD: `${MiddlewareEntities.PRODUCT} SET_INSTALLMENTS_OVER_BILL_PERIOD`,
      SET_PURCHASE: `${MiddlewareEntities.PRODUCT} SET_PURCHASE`,
      SET_CONTRACT_TYPE: `${MiddlewareEntities.PRODUCT} SET_CONTRACT_TYPE`,
      GET_PRODUCT_DATA_FROM_LOCAL_STORAGE: `${MiddlewareEntities.PRODUCT} GET_PRODUCT_DATA_FROM_LOCAL_STORAGE`,
    },
    PRODUCT_VALIDATOR: `${MiddlewareEntities.PRODUCT} PRODUCT_VALIDATOR`,
    SET_RECENTLY_VIEWED_IN_LOCAL_STORAGE: `${MiddlewareEntities.PRODUCT} SET_RECENTLY_VIEWED_IN_LOCAL_STORAGE`,
    SET_RECENTLY_VIEWED: `${MiddlewareEntities.PRODUCT} SET_RECENTLY_VIEWED`,
    GET_RECENTLY_VIEWED: `${MiddlewareEntities.PRODUCT} GET_RECENTLY_VIEWED`,
    TRANSFORM_PRODUCT_RESPONSE: `${MiddlewareEntities.PRODUCT} TRANSFORM_PRODUCT_RESPONSE`,
    FETCH_PRODUCT_INSURANCE: `${MiddlewareEntities.PRODUCT_INSURANCE} FETCH_PRODUCT_INSURANCE`,
    SET_PRODUCT_INSURANCE: `${MiddlewareEntities.PRODUCT_INSURANCE} SET_PRODUCT_INSURANCE`,
    ENRICH_PRODUCT_INSURANCE: `${MiddlewareEntities.PRODUCT_INSURANCE} ENRICH_PRODUCT_INSURANCE`,
    SUBMIT_PRODUCT_INSURANCE: `${MiddlewareEntities.PRODUCT_INSURANCE} SUBMIT_PRODUCT_INSURANCE`,
    SET_SELECTED_INSURANCE: `${MiddlewareEntities.PRODUCT_INSURANCE} SET_SELECTED_INSURANCE`,
    CLEAR_SELECTED_INSURANCE: `${MiddlewareEntities.PRODUCT_INSURANCE} CLEAR_SELECTED_INSURANCE`,
    SET_PRE_BASKET_PRODUCTS: `${MiddlewareEntities.PRODUCT} SET_PRE_BASKET_PRODUCTS`,
    REMOVE_PRE_BASKET_PRODUCT: `${MiddlewareEntities.PRODUCT} REMOVE_PRE_BASKET_PRODUCT`,
    SET_PRE_BASKET_PRODUCT_DATA: `${MiddlewareEntities.PRODUCT} SET_PRE_BASKET_PRODUCT_DATA`,
    SET_PRE_BASKET_PRODUCT_IN_SESSION_STORAGE: `${MiddlewareEntities.PRODUCT} SET_PRE_BASKET_PRODUCT_IN_SESSION_STORAGE`,
    GET_PRE_BASKET: `${MiddlewareEntities.PRODUCT} GET_PRE_BASKET`,
    SET_EDIT_MODE: `${MiddlewareEntities.PRODUCT} SET_EDIT_MODE`,
    SET_EDIT_MODE_IN_SESSION_STORAGE: `${MiddlewareEntities.PRODUCT} SET_EDIT_MODE_IN_SESSION_STORAGE`,
    CLEAR_PRE_BASKET: `${MiddlewareEntities.PRODUCT} CLEAR_PRE_BASKET`,
    PRE_BASKET_TRANSFORM_PRODUCT_RESPONSE: `${MiddlewareEntities.PRODUCT} PRE_BASKET_TRANSFORM_PRODUCT_RESPONSE`,
    GET_PRODUCT_SUGGESTIONS: `${MiddlewareEntities.PRODUCT} GET_PRODUCT_SUGGESTIONS`,
    SET_PRODUCT_SUGGESTIONS: `${MiddlewareEntities.PRODUCT} SET_PRODUCT_SUGGESTIONS`,
    ENRICH_PRODUCT_SUGGESTIONS: `${MiddlewareEntities.PRODUCT} ENRICH_PRODUCT_SUGGESTIONS`,
  },
  FILTERS_LIST: {
    SET: `${MiddlewareEntities.FILTERS_LIST} SET_FILTERS_LIST`,
    CREATE: `${MiddlewareEntities.FILTERS_LIST} CREATE_FILTERS_LIST`,
    CLEAR: `${MiddlewareEntities.FILTERS_LIST} CLEAR_FILTERS_LIST`,
  },
  SEARCH_PARAMS: {
    PRODUCT_LIST: {
      CLEAR: `${MiddlewareEntities.SEARCH_PARAMS} CLEAR_PRODUCT_LIST`,
      CREATE: `${MiddlewareEntities.SEARCH_PARAMS} CREATE_PRODUCT_LIST`,
      SEARCH: `${MiddlewareEntities.SEARCH_PARAMS} SEARCH_PRODUCT_LIST`,
      SET: `${MiddlewareEntities.SEARCH_PARAMS} SET_PRODUCT_LIST`,
    },
    PRODUCT_OVERVIEW: {
      CLEAR: `${MiddlewareEntities.SEARCH_PARAMS} CLEAR_PRODUCT_OVERVIEW`,
      CREATE: `${MiddlewareEntities.SEARCH_PARAMS} CREATE_PRODUCT_OVERVIEW`,
      SET: `${MiddlewareEntities.SEARCH_PARAMS} SET_PRODUCT_OVERVIEW`,
    },
    MANHATTAN: {
      CLEAR: `${MiddlewareEntities.SEARCH_PARAMS} CLEAR_MANHATTAN`,
      CREATE: `${MiddlewareEntities.SEARCH_PARAMS} CREATE_MANHATTAN`,
      SET: `${MiddlewareEntities.SEARCH_PARAMS} SET_MANHATTAN`,
    },
  },
  PAGE_DATA: {
    FETCH: `${MiddlewareEntities.PAGE_DATA} FETCH`,
    SET: `${MiddlewareEntities.PAGE_DATA} SET`,
    PROCESS: `${MiddlewareEntities.PAGE_DATA} PROCESS`,
  },
  PAGE_DATA_DEVICE_LIST: {
    FETCH: `${MiddlewareEntities.PAGE_DATA_DEVICE_LIST} FETCH`,
    SET: `${MiddlewareEntities.PAGE_DATA_DEVICE_LIST} SET`,
    PROCESS: `${MiddlewareEntities.PAGE_DATA_DEVICE_LIST} PROCESS`,
  },
  PAGE_DATA_DEVICE_OVERVIEW: {
    FETCH: `${MiddlewareEntities.PAGE_DATA_DEVICE_OVERVIEW} FETCH`,
    SET: `${MiddlewareEntities.PAGE_DATA_DEVICE_OVERVIEW} SET`,
    PROCESS: `${MiddlewareEntities.PAGE_DATA_DEVICE_OVERVIEW} PROCESS`,
  },
  PAGE_SHELL: {
    FETCH_SESSION: `${MiddlewareEntities.PAGE_SHELL} FETCH_SESSION`,
    FETCH_HEADER: `${MiddlewareEntities.SITE_HEADER} FETCH_HEADER`,
    SET: `${MiddlewareEntities.PAGE_SHELL} SET`,
    PROCESS: `${MiddlewareEntities.PAGE_SHELL} PROCESS`,
    SET_LOGIN_DATA: `${MiddlewareEntities.PAGE_SHELL} SET_LOGIN_DATA`,
  },
  NOTIFICATION: {
    GET: `${MiddlewareEntities.NOTIFICATION} GET`,
    SET: `${MiddlewareEntities.NOTIFICATION} SET`,
    REMOVE: `${MiddlewareEntities.NOTIFICATION} REMOVE`,
    CLEAR: `${MiddlewareEntities.NOTIFICATION} CLEAR`,
    CREATE_ERROR: `${MiddlewareEntities.NOTIFICATION} CREATE_ERROR`,
    VALIDATE_NOTIFICATION: `${MiddlewareEntities.NOTIFICATION} VALIDATE_NOTIFICATION`,
  },
  USER_MESSAGE: {
    SET: `${MiddlewareEntities.USER_MESSAGE} SET`,
    REMOVE: `${MiddlewareEntities.USER_MESSAGE} REMOVE`,
  },
  MENU: {
    SHOW_ITEMS: '[MENU] SHOW_ITEMS',
    HIDE_ITEMS: '[MENU] HIDE_ITEMS',
    SET_ITEMS: '[MENU] SET ITEMS',
    SHOW_MOBILE: '[MENU] SHOW_MOBILE',
    HIDE_MOBILE: '[MENU] HIDE_MOBILE',
    HIDE_MOBILE_SUBMENU_ITEMS: '[MENU] HIDE_MOBILE_SUBMENU_ITEMS',
    SHOW_LOGIN_ITEMS: '[MENU] SHOW_LOGIN_ITEMS',
  },
  SECTION: {
    SET: `${MiddlewareEntities.SECTION} SET`,
  },
  LANGUAGE: {
    CHANGE: `${MiddlewareEntities.LANGUAGE} CHANGE`,
    SET: `${MiddlewareEntities.LANGUAGE} SET`,
  },
  SESSION_DATA: {
    GET: `${MiddlewareEntities.SESSION_DATA} GET`,
    SET: `${MiddlewareEntities.SESSION_DATA} SET`,
  },
  CAPTCHA: {
    CALL_LAST_REQUEST: `${MiddlewareEntities.CAPTCHA} CALL_LAST_REQUEST`,
  },
  STORES_MAP: {
    GET_ALL_STORES: `${MiddlewareEntities.STORES_MAP} GET_ALL_STORES`,
    CREATE: `${MiddlewareEntities.STORES_MAP} CREATE`,
    SET_VISIBILITY: `${MiddlewareEntities.STORES_MAP} SET_VISIBILITY`,
    SET_STORES: `${MiddlewareEntities.STORES_MAP} SET_STORES`,
    CLOSE: `${MiddlewareEntities.STORES_MAP} CLOSE`,
    FETCH: `${MiddlewareEntities.STORES_MAP} FETCH`,
    GET_USER_GEO_LOCATION: `${MiddlewareEntities.STORES_MAP} GET_USER_GEO_LOCATION`,
    SET_MAP_CENTER: `${MiddlewareEntities.STORES_MAP} SET_MAP_CENTER`,
    SET_ACTIVE_STORE_ID: `${MiddlewareEntities.STORES_MAP} SET_ACTIVE_STORE_ID`,
    SET_STORE_FILTER: `${MiddlewareEntities.STORES_MAP} SET_STORE_FILTER`,
    SET_CLOSEST_STORES_STATUS: `${MiddlewareEntities.STORES_MAP} SET_CLOSEST_STORES_STATUS`,
    GET_CLOSEST_STORES: `${MiddlewareEntities.STORES_MAP} GET_CLOSEST_STORES`,
    SET_CITIES: `${MiddlewareEntities.STORES_MAP} SET_CITIES`,
    GET_CITIES: `${MiddlewareEntities.STORES_MAP} GET_CITIES`,
    SET_USER_GEO_LOCATION: `${MiddlewareEntities.STORES_MAP} SET_USER_GEO_LOCATION`,
    GET_ONLY_STORES: `${MiddlewareEntities.STORES_MAP} GET_ONLY_STORES`,
    GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY: `${MiddlewareEntities.STORES_MAP} GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY`,
    GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY_COMPLEX: `${MiddlewareEntities.STORES_MAP} GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY_COMPLEX`,
    GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY_AND_SET_ACTIVE_ID: `${MiddlewareEntities.STORES_MAP} GET_MULTIPLE_PRODUCT_STORE_AVAILABILITY_AND_SET_ACTIVE_ID`,
    SET_FIVE_CLOSEST_STATUS: `${MiddlewareEntities.STORES_MAP} SET_FIVE_CLOSEST_STATUS`,
    CAMPAIGN_CREATE: `${MiddlewareEntities.STORES_MAP} CAMPAIGN_CREATE`,
    ONLY_STORES_CREATE: `${MiddlewareEntities.STORES_MAP} ONLY_STORES_CREATE`,
  },

  MANHATTAN: {
    FTTH: {
      FTTH_PRODUCT: {
        FETCH: `${MiddlewareEntities.MANHATTAN.FTTH.FTTH_PRODUCT} FETCH`,
        SET: `${MiddlewareEntities.MANHATTAN.FTTH.FTTH_PRODUCT} SET`,
        ENRICH: `${MiddlewareEntities.MANHATTAN.FTTH.FTTH_PRODUCT} ENRICH`,
      },
      SINGLE_PRODUCT: {
        REMOVE_PURCHASE_FROM_SINGLE_PRODUCT: `${MiddlewareEntities.MANHATTAN.FTTH.SINGLE_PRODUCT} REMOVE_PURCHASE_FROM_SINGLE_PRODUCT`,
        SET_PURCHASE_MANHATTAN: `${MiddlewareEntities.MANHATTAN.FTTH.SINGLE_PRODUCT} SET_PURCHASE_MANHATTAN`,
        CHANGE_PURCHASE_MANHATTAN: `${MiddlewareEntities.MANHATTAN.FTTH.SINGLE_PRODUCT} CHANGE_PURCHASE_MANHATTAN`,
      },
      ADDITIONAL_DEVICES: {
        SET_VISIBILITY: `${MiddlewareEntities.MANHATTAN.FTTH.ADDITIONAL_DEVICES} SET_VISIBILITY`,
        SET_STB_NUMBER: `${MiddlewareEntities.MANHATTAN.FTTH.ADDITIONAL_DEVICES} SET_STB_NUMBER`,
        SET_SELECTED_STB_NUMBER: `${MiddlewareEntities.MANHATTAN.FTTH.ADDITIONAL_DEVICES} SET_SELECTED_STB_NUMBER`,
      },
    },
    POST_OTT: {
      SINGLE_PRODUCT: {
        REMOVE_PURCHASE_FROM_SINGLE_PRODUCT: `${MiddlewareEntities.MANHATTAN.POST_OTT.SINGLE_PRODUCT} REMOVE_PURCHASE_FROM_SINGLE_PRODUCT`,
        SET_PURCHASE_MANHATTAN: `${MiddlewareEntities.MANHATTAN.POST_OTT.SINGLE_PRODUCT} SET_PURCHASE_MANHATTAN`,
        CHANGE_PURCHASE_MANHATTAN: `${MiddlewareEntities.MANHATTAN.POST_OTT.SINGLE_PRODUCT} CHANGE_PURCHASE_MANHATTAN`,
      },
    },
    OTT: {
      FETCH: `${MiddlewareEntities.MANHATTAN.OTT.OTT_PRODUCT} FETCH`,
      GET: `${MiddlewareEntities.MANHATTAN.OTT.OTT_PRODUCT} GET`,
      SET_PRODUCT: `${MiddlewareEntities.MANHATTAN.OTT.OTT_PRODUCT} SET_PRODUCT`,
    },
    BUNDLE: {
      SET: `${MiddlewareEntities.MANHATTAN.BUNDLE} SET`,
      FETCH: `${MiddlewareEntities.MANHATTAN.BUNDLE} FETCH`,
      VALIDATOR: `${MiddlewareEntities.MANHATTAN.BUNDLE} VALIDATOR`,
    },
    BUNDLE_DATA: {
      GET_DATA: `${MiddlewareEntities.MANHATTAN.BUNDLE} GET_DATA`,
      SET_DATA: `${MiddlewareEntities.MANHATTAN.BUNDLE} SET_DATA`,
      SET_SELECTED_PRODUCTS: `${MiddlewareEntities.MANHATTAN.BUNDLE} SET_SELECTED_PRODUCTS`,
    },
  },
  AVAILABILITY_PRODUCT: {
    GET: `${MiddlewareEntities.AVAILABILITY_PRODUCT} GET`,
    SET: `${MiddlewareEntities.AVAILABILITY_PRODUCT} SET`,
    SET_LOADER: `${MiddlewareEntities.AVAILABILITY_PRODUCT} SET_LOADER`,
  },
  CONTRACT: {
    MANHATTAN: {
      FETCH_CONTRACTS: `${MiddlewareEntities.CONTRACT.MANHATTAN} FETCH_CONTRACTS`,
      GET_CONTRACTS: `${MiddlewareEntities.CONTRACT.MANHATTAN} GET_CONTRACTS`,
      SET_CONTRACTS: `${MiddlewareEntities.CONTRACT.MANHATTAN} SET_CONTRACTS`,
      SET_CONTRACT_IN_SESSION_STORAGE: `${MiddlewareEntities.CONTRACT.MANHATTAN} SET_CONTRACT_IN_SESSION_STORAGE`,
    },
  },
  ORDER: {
    SUBMIT: `${MiddlewareEntities.ORDER.BASIC_ORDER} SUBMIT`,
    SUBMIT_ACCESSORIES: `${MiddlewareEntities.ORDER.BASIC_ORDER} SUBMIT_ACCESSORIES`,
    SET_CART_CONFLICT_DATA: `${MiddlewareEntities.ORDER.BASIC_ORDER} SET_CART_CONFLICT_DATA`,
    RESOLVE_CONFLICT: `${MiddlewareEntities.ORDER.BASIC_ORDER} RESOLVE_CONFLICT`,
    SET_RESOLVING_IN_PROGRESS: `${MiddlewareEntities.ORDER.BASIC_ORDER} SET_RESOLVING_IN_PROGRESS`,
    SET_SMS_FLAGS: `${MiddlewareEntities.ORDER.BASIC_ORDER} SET_SMS_FLAGS`,
    SEND_VERIFICATION_SMS: `${MiddlewareEntities.ORDER.BASIC_ORDER} SEND_VERIFICATION_SMS`,
    SEND_VERIFICATION_SMS_SUCCESS: `${MiddlewareEntities.ORDER.BASIC_ORDER} SEND_VERIFICATION_SMS_SUCCESS`,
    SEND_VERIFICATION_CODE: `${MiddlewareEntities.ORDER.BASIC_ORDER} SEND_VERIFICATION_CODE`,
    SEND_VERIFICATION_CODE_SUCCESS: `${MiddlewareEntities.ORDER.BASIC_ORDER} SEND_VERIFICATION_CODE_SUCCESS`,
    CLEAR_BASKET: `${MiddlewareEntities.ORDER.BASIC_ORDER} CLEAR_BASKET`,
    MANHATTAN: {
      SUBMIT: `${MiddlewareEntities.ORDER.MANHATTAN_SUBMIT}`,
      PURCHASE_FTTH_SUBMIT: `${MiddlewareEntities.ORDER.MANHATTAN_PURCHASE_FTTH_SUBMIT}`,
      SET_ORDER_CART_CONFLICT_DATA: `${MiddlewareEntities.ORDER.MANHATTAN_SUBMIT} SET_ORDER_CART_CONFLICT_DATA`,
      RESOLVE_ORDER_CONFLICT: `${MiddlewareEntities.ORDER.MANHATTAN_SUBMIT} RESOLVE_ORDER_CONFLICT`,
      SET_RESOLVING_ORDER_IN_PROGRESS: `${MiddlewareEntities.ORDER.MANHATTAN_SUBMIT} SET_RESOLVING_ORDER_IN_PROGRESS`,
      GET_ORDER: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} GET_ORDER`,
      SET_ORDER_TYPE: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SET_ORDER_TYPE`,
      SET_ORDER_STATE: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SET_ORDER_STATE`,
      FETCH_ORDER: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} FETCH_ORDER`,
      SET_ORDER: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SET_ORDER`,
      ORDER_VALIDATOR: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} ORDER_VALIDATOR`,
      SET_CHECKOUT_DATA: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SET_CHECKOUT_DATA`,
      SET_CUSTOMER_INPUT_DATA: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SET_CUSTOMER_INPUT_DATA`,
      GO_TO_NEXT_STEP: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} GO_TO_NEXT_STEP`,
      GO_TO_PREVIOUS_STEP: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} GO_TO_PREVIOUS_STEP`,
      SUBMIT_ORDER_DATA_STEP: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SUBMIT_ORDER_DATA_STEP`,
      SUBMIT_ORDER_PREVIOUS_DATA_STEP: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SUBMIT_ORDER_PREVIOUS_DATA_STEP`,
      CANCEL_ORDER: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} CANCEL_ORDER`,
      SET_DEFAULT_CHECKOUT_DATA: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SET_DEFAULT_CHECKOUT_DATA`,
      SEND_ORDER_TO_EMAIL: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SEND_ORDER_TO_EMAIL`,
      SET_SEND_ORDER_TO_EMAIL_STATUS: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SET_SEND_ORDER_TO_EMAIL_STATUS`,
      SET_ORE: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SET_ORE`,
      CHANGE_DEVICE_COLOR: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} CHANGE_DEVICE_COLOR`,
      UPDATE_DEVICE_COLOR: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} UPDATE_DEVICE_COLOR`,
      UPDATE_COLOR_CHANGE_IN_PROGRESS_STATUS: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} UPDATE_COLOR_CHANGE_IN_PROGRESS_STATUS`,
      REMOVE_ITEM_FROM_BASKET: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} REMOVE_ITEM_FROM_BASKET`,
      UPDATE_FULL_ITEM_LOADER_STATUS: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} UPDATE_FULL_ITEM_LOADER_STATUS`,
      PREPARE_BASKET_ITEM_FOR_REPLACEMENT: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} PREPARE_BASKET_ITEM_FOR_REPLACEMENT`,
      CAN_CONTINUE: `${MiddlewareEntities.ORDER.MANHATTAN.ORDER} SET_MANHATTAN_ORDER_CAN_CONTINUE`,
    },
    VOUCHER: {
      SEND_FOR_VERIFICATION: `${MiddlewareEntities.ORDER.TELCO.ORDER} SEND_FOR_VERIFICATION`,
      SET_VOUCHER_CODE: `${MiddlewareEntities.ORDER.TELCO.ORDER} SET_VOUCHER_CODE`,
      SET_MSISDN_REQUIRED: `${MiddlewareEntities.ORDER.TELCO.ORDER} SET_MSISDN_REQUIRED`,
    },
    ACCESSORY: {
      VOUCHER: {
        SEND_FOR_VERIFICATION: `${MiddlewareEntities.ORDER.ACCESSORY.ORDER} SEND_FOR_VERIFICATION`,
        SET_VOUCHER_CODE: `${MiddlewareEntities.ORDER.TELCO.ORDER} SET_VOUCHER_CODE`,
        SET_MSISDN_REQUIRED: `${MiddlewareEntities.ORDER.TELCO.ORDER} SET_MSISDN_REQUIRED`,
      },
    },
    GREEN_VOUCHER: {
      SEND_FOR_VERIFICATION: `${MiddlewareEntities.ORDER.GREEN_VOUCHER.SEND_VOUCHER_FOR_VERIFICATION} SEND_FOR_VERIFICATION`,
      SET_VOUCHER_APPLIED: `${MiddlewareEntities.ORDER.GREEN_VOUCHER.SEND_VOUCHER_FOR_VERIFICATION} SET_VOUCHER_APPLIED`,
      SET_VOUCHER_FAILED_MESSAGE: `${MiddlewareEntities.ORDER.GREEN_VOUCHER.SET_VOUCHER_FAILED_MESSAGE} SET_VOUCHER_FAILED_MESSAGE`,
      SET_DEVICE_NUMBER_SPECIFIED: `${MiddlewareEntities.ORDER.GREEN_VOUCHER.SET_DEVICE_NUMBER_SPECIFIED} SET_DEVICE_NUMBER_SPECIFIED`,
      CLEAR_APPLIED_VOUCHER: `${MiddlewareEntities.ORDER.GREEN_VOUCHER.SEND_VOUCHER_FOR_VERIFICATION} CLEAR_APPLIED_VOUCHER`,
    }
  },
  TRANSACTION: {
    FETCH_TRANSACTION_WITH_HASH: `${MiddlewareEntities.TRANSACTION} FETCH_TRANSACTION_WITH_HASH`,
    FETCH_TRANSACTION_WITH_SAID: `${MiddlewareEntities.TRANSACTION} FETCH_TRANSACTION_WITH_SAID`,
    CANCEL_TRANSACTION: `${MiddlewareEntities.CANCEL_TRANSACTION} CANCEL_TRANSACTION`,
    SET_TRANSACTION: `${MiddlewareEntities.TRANSACTION} SET_TRANSACTION`,
    SET_TRANSACTION_STATUS: `${MiddlewareEntities.TRANSACTION} SET_TRANSACTION_STATUS`,
    CANCEL_P2P_TRANSACTION: `${MiddlewareEntities.TRANSACTION} CANCEL_P2P_TRANSACTION`,
  },
  REDIRECT_TO: "REDIRECT_TO",
  REFRESH_PAGE: "REFRESH_PAGE",
  CAMPAIGN: {
    FETCH_ALL: `${MiddlewareEntities.CAMPAIGN.ALL} FETCH_ALL`,
    FETCH: `${MiddlewareEntities.CAMPAIGN.ALL} FETCH`,
    LIST: {
      CREATE: `${MiddlewareEntities.CAMPAIGN.ALL} CREATE`,
      SET_WEBOS_SOFT: `${MiddlewareEntities.CAMPAIGN.ALL} SET_WEBOS_SOFT`,
      SET_CHANNEL01_SOFT: `${MiddlewareEntities.CAMPAIGN.ALL} SET_CHANNEL01_SOFT`,
      SET_WEBOS_ORE: `${MiddlewareEntities.CAMPAIGN.ALL} SET_WEBOS_ORE`,
      SET_CHANNEL01_ORE: `${MiddlewareEntities.CAMPAIGN.ALL} SET_CHANNEL01_ORE`,
      SET_CURRENT_TP: `${MiddlewareEntities.CAMPAIGN.ALL} SET_CURRENT_TP`,
      VALIDATOR_GET_ALL_CAMPAIGNS: `${MiddlewareEntities.CAMPAIGN.ALL} VALIDATOR_GET_ALL_CAMPAIGNS`,
    },
    OVERVIEW: {
      CREATE: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} CREATE`,
      SET_SOFT_OFFER_PACKAGE: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_SOFT_OFFER_PACKAGE`,
      SET_OPTION_NAME: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_OPTION_NAME`,
      SET_TERMS: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_TERMS`,
      SET_CM_USER: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_CM_USER`,
      CSS_STATUS: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} CSS_STATUS`,
      CHECK_CSS_STATUS: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} CHECK_CSS_STATUS`,
      SET_USER_TERMS_STATUS: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_USER_TERMS_STATUS`,
      SET_IS_ACTIVE_CONTACT_FOR_MSISDN: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_IS_ACTIVE_CONTACT_FOR_MSISDN`,
      SET_CONTACT_EMAIL: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_CONTACT_EMAIL`,
      SET_ESIM_CARD: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_ESIM_CARD`,
      SET_EMAIL_WAS_VALIDATED: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_EMAIL_WAS_VALIDATED`,
      SET_DELIVERY_OPTION: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_DELIVERY_OPTION`,
      SET_SELECTED_STORE_ID: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_SELECTED_STORE_ID`,
      SET_OFFER_ADDITIONAL_DATA: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_OFFER_ADDITIONAL_DATA`,
      SET_DELIVERY_ADDRESS: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} SET_DELIVERY_ADDRESS`,
      CLEAR_DELIVERY_ADDRESS: `${MiddlewareEntities.CAMPAIGN.OVERVIEW_DATA} CLEAR_DELIVERY_ADDRESS`,
      SUBMIT: `${MiddlewareEntities.CAMPAIGN.ALL} CAMPAIGN_OVERVIEW_SUBMIT`,
      SUBMIT_PROCESS: `${MiddlewareEntities.CAMPAIGN.ALL} SUBMIT_PROCESS`,
    },
    CALL_ME: `${MiddlewareEntities.CAMPAIGN.CAMPAIGN_HELP} CALL_ME`,
    CONSENT: {
      CREATE: `${MiddlewareEntities.CAMPAIGN.CONSENT} CREATE`,
      SET_FROM_RESPONSE: `${MiddlewareEntities.CAMPAIGN.CONSENT} SET_FROM_RESPONSE`,
      SET_GLOBAL_CONSENT: `${MiddlewareEntities.CAMPAIGN.CONSENT} SET_GLOBAL_CONSENT`,
      SET_COSMOS_CONSENT: `${MiddlewareEntities.CAMPAIGN.CONSENT} SET_COSMOS_CONSENT`,
      SET_SOCIAL_NETWORKS_OFFERING_CONSENT: `${MiddlewareEntities.CAMPAIGN.CONSENT} SET_SOCIAL_NETWORKS_OFFERING_CONSENT`,
      SET_SOCIAL_NETWORKS_MATCHING_CONSENT: `${MiddlewareEntities.CAMPAIGN.CONSENT} SET_SOCIAL_NETWORKS_MATCHING_CONSENT`,
    },
    ACCEPTANCE: {
      FETCH: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} FETCH`,
      SET_ACCEPTANCE_DATA: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} SET_ACCEPTANCE_DATA`,
      SET_ACCEPTANCE_OFFER_PACKAGE: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} SET_ACCEPTANCE_OFFER_PACKAGE`,
      SET_ACCEPTANCE_OPTION_NAME: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} SET_ACCEPTANCE_OPTION_NAME`,
      GIVE_ACCEPTANCE: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} GIVE_ACCEPTANCE`,
      SET_STATUS: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} SET_STATUS`,
      SET_TERMS: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} SET_TERMS`,
      SEND_REQUEST: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} SEND_REQUEST`,
      SET_ACCEPTANCE_STATUS: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} SET_ACCEPTANCE_STATUS`,
      SET_ACCEPTANCE_REQUEST_SMS_STATUS: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} SET_ACCEPTANCE_REQUEST_SMS_STATUS`,
      SET_ACCEPTANCE_REQUEST_EMAIL_STATUS: `${MiddlewareEntities.CAMPAIGN.ACCEPTANCE.ALL} SET_ACCEPTANCE_REQUEST_EMAIL_STATUS`,
    },
    DETAILS: {
      FETCH: `${MiddlewareEntities.CAMPAIGN.DETAILS} FETCH`,
      CREATE: `${MiddlewareEntities.CAMPAIGN.DETAILS} CREATE`,
      SET_SOFT_OFFER_PACKAGE: `${MiddlewareEntities.CAMPAIGN.DETAILS} SET_SOFT_OFFER_PACKAGE`,
      SET_OPTION_NAME: `${MiddlewareEntities.CAMPAIGN.DETAILS} SET_OPTION_NAME`,
      SET_DETAILS_TERMS: `${MiddlewareEntities.CAMPAIGN.DETAILS} SET_DETAILS_TERMS`,
      SET_DETAILS_IS_UP_SELL: `${MiddlewareEntities.CAMPAIGN.DETAILS} SET_DETAILS_IS_UP_SELL`,
      SET_DETAILS_OFFER_ID: `${MiddlewareEntities.CAMPAIGN.DETAILS} SET_DETAILS_OFFER_ID`,
      SET_DETAILS_OPTION_ID: `${MiddlewareEntities.CAMPAIGN.DETAILS} SET_DETAILS_OPTION_ID`,
      SET_DETAILS_CHANNEL_NAME: `${MiddlewareEntities.CAMPAIGN.DETAILS} SET_DETAILS_CHANNEL_NAME`,
      SET_SUBMIT_EANEX_MESSAGE: `${MiddlewareEntities.CAMPAIGN.DETAILS} SET_SUBMIT_EANEX_MESSAGE`,
      SUBMIT_EANEX: `${MiddlewareEntities.CAMPAIGN.DETAILS} SUBMIT_EANEX`,
    },
    SOFT_ELECTRO: {
      SET_SUBMIT_STATUS: `${MiddlewareEntities.CAMPAIGN.SOFT_ELECTRO} SET_SUBMIT_STATUS`,
      SET_SUBMIT_MESSAGE: `${MiddlewareEntities.CAMPAIGN.SOFT_ELECTRO} SET_SUBMIT_MESSAGE`,
      RESEND_OFFER: `${MiddlewareEntities.CAMPAIGN.SOFT_ELECTRO} RESEND_OFFER`,
      SEND_NEW_OFFER: `${MiddlewareEntities.CAMPAIGN.SOFT_ELECTRO} SEND_NEW_OFFER`,
      CANCEL_OFFER: `${MiddlewareEntities.CAMPAIGN.SOFT_ELECTRO} CANCEL_OFFER`,
    },
    CAMPAIGN_MODE: {
      SET_CAMPAIGN_MODE_STATUS: `${MiddlewareEntities.CAMPAIGN.MODE} SET_CAMPAIGN_MODE_STATUS`,
      SET_CAMPAIGN_MODE_RECOMMENDED_TP_TMCODE: `${MiddlewareEntities.CAMPAIGN.MODE} SET_CAMPAIGN_MODE_RECOMMENDED_TP_TMCODE`,
      SET_CAMPAIGN_MODE_AVAILABLE_TP_TMCODES: `${MiddlewareEntities.CAMPAIGN.MODE} SET_CAMPAIGN_MODE_AVAILABLE_TP_TMCODES`,
      SET_CAMPAIGN_ORE_SUBMIT_DATA: `${MiddlewareEntities.CAMPAIGN.MODE} SET_CAMPAIGN_ORE_SUBMIT_DATA`,
      CLEAR_CAMPAIGN_MODE: `${MiddlewareEntities.CAMPAIGN.MODE} CLEAR_CAMPAIGN_MODE`,
      CHECK_FOR_ORE_SUBMIT_DATA: `${MiddlewareEntities.CAMPAIGN.MODE} CHECK_FOR_ORE_SUBMIT_DATA`,
      GET_ORE_SUBMIT_DATA_FROM_BACKUP: `${MiddlewareEntities.CAMPAIGN.MODE} GET_ORE_SUBMIT_DATA_FROM_BACKUP`,
    },
  },
  PAK: {
    FETCH_CITIES: `${MiddlewareEntities.PAK.PAK_CITY} FETCH_CITIES`,
    SET_CITIES: `${MiddlewareEntities.PAK.PAK_CITY} SET_CITIES`,
    FETCH_NEIGHBORHOODS: `${MiddlewareEntities.PAK.PAK_NEIGHBORHOOD} FETCH_NEIGHBORHOODS`,
    SET_NEIGHBORHOODS: `${MiddlewareEntities.PAK.PAK_NEIGHBORHOOD} SET_NEIGHBORHOODS`,
    FETCH_STREETS: `${MiddlewareEntities.PAK.PAK_STREET} FETCH_STREETS`,
    SET_STREETS: `${MiddlewareEntities.PAK.PAK_STREET} SET_STREETS`,
  },
  COMPARE: {
    SET_PRODUCT: `${MiddlewareEntities.COMPARE.MAIN} SET_PRODUCT`,
    REMOVE_PRODUCT: `${MiddlewareEntities.COMPARE.MAIN} REMOVE_PRODUCT`,
    CHANGE_PRODUCT: `${MiddlewareEntities.COMPARE.MAIN} CHANGE_PRODUCT`,
    DESELECT_ALL: `${MiddlewareEntities.COMPARE.MAIN} DESELECT_ALL`,
    TOGGLE_COMPARE_DASHBOARD: `${MiddlewareEntities.COMPARE.MAIN} TOGGLE_COMPARE_DASHBOARD`,
    COMPARE_PRODUCT_SWITCH: `${MiddlewareEntities.COMPARE.MAIN} COMPARE_PRODUCT_SWITCH`,
    TOGGLE_COMPARE_SHOW_DIFFS: `${MiddlewareEntities.COMPARE.MAIN} TOGGLE_COMPARE_SHOW_DIFFS`,
    NORMALIZE_COMPARE_PRODUCTS: `${MiddlewareEntities.COMPARE.MAIN} NORMALIZE_COMPARE_PRODUCTS`,
    FETCH: `${MiddlewareEntities.COMPARE.MAIN} FETCH`,
    SET_COMPARE_DATA: `${MiddlewareEntities.COMPARE.MAIN} SET_COMPARE_DATA`,
  },
  WISH_LIST: {
    GET_PRODUCTS: `${MiddlewareEntities.WISH_LIST.PRODUCTS} GET_PRODUCTS`,
    SET_PRODUCTS: `${MiddlewareEntities.WISH_LIST.PRODUCTS} SET_PRODUCTS`,
    SET_PRODUCT_IDS: `${MiddlewareEntities.WISH_LIST.PRODUCTS} SET_PRODUCT_IDS`,
    CHANGE_PRODUCT: `${MiddlewareEntities.WISH_LIST.CHANGE} CHANGE_PRODUCT`,
    SAVE_PRODUCT_AFTER_LOGIN: `${MiddlewareEntities.WISH_LIST.CHANGE} SAVE_PRODUCT_AFTER_LOGIN`,
    ADD_PRODUCT_ON_WISH_LIST: `${MiddlewareEntities.WISH_LIST.CHANGE} ADD_PRODUCT_ON_WISH_LIST`,
    REMOVE_PRODUCT_FROM_WISH_LIST: `${MiddlewareEntities.WISH_LIST.CHANGE} REMOVE_PRODUCT_FROM_WISH_LIST`,
  },
  AUTH: {
    SET_USER_PROFILE_FROM_TN_ACCOUNT: `${MiddlewareEntities.AUTH.LOGIN} SET_USER_PROFILE_FROM_TN_ACCOUNT`,
    LOGOUT_FROM_TN_ACCOUNT: `${MiddlewareEntities.AUTH.LOGOUT} LOGOUT_FROM_TN_ACCOUNT`,
  },
  COOKIE: {
    COMPARE_COOKIE_TOKEN: `${MiddlewareEntities.COOKIE.COMPARE_COOKIE_TOKEN} COMPARE_COOKIE_TOKEN`,
    SET_SHOULD_CALL_LOGIN: `${MiddlewareEntities.AUTH.LOGIN} SET_SHOULD_CALL_LOGIN`,
  },
  SSO: {
    FETCH_SSO_TOKEN: `${MiddlewareEntities.AUTH.SSO} FETCH_SSO_TOKEN`,
    GET_SSO_REDIRECT: `${MiddlewareEntities.AUTH.SSO} GET_SSO_REDIRECT`,
    FETCH_SSO_TEST_TOKEN: `${MiddlewareEntities.AUTH.SSO_TEST} FETCH_SSO_TEST_TOKEN`,
    SET_SSO_TEST_TOKEN: `${MiddlewareEntities.AUTH.SSO_TEST} SET_SSO_TEST_TOKEN`,
    GET_SSO_TEST_REDIRECT: `${MiddlewareEntities.AUTH.SSO_TEST} GET_SSO_TEST_REDIRECT`,
    FETCH_SSO_TEST_DATA: `${MiddlewareEntities.AUTH.SSO_TEST_DATA} FETCH_SSO_TEST_DATA`,
    SET_SSO_TEST_DATA: `${MiddlewareEntities.AUTH.SSO_TEST_DATA} SET_SSO_TEST_DATA`,
  },
  ANALYTICS: {
    DEVICE_IMPRESSIONS: `${MiddlewareEntities.ANALYTICS} DEVICE_IMPRESSIONS`,
    DEVICE_CLICK_FROM_LIST: `${MiddlewareEntities.ANALYTICS} DEVICE_CLICK_FROM_LIST`,
    DEVICE_OVERVIEW: `${MiddlewareEntities.ANALYTICS} DEVICE_OVERVIEW`,
    ADD_TO_BASKET: `${MiddlewareEntities.ANALYTICS} ADD_TO_BASKET`,
    VIEW_CART: `${MiddlewareEntities.ANALYTICS} VIEW_CART`,
    DEVICE_OVERVIEW_PLAN_CHANGE: `${MiddlewareEntities.ANALYTICS} DEVICE_OVERVIEW_PLAN_CHANGE`,
    EMPTY_CART: `${MiddlewareEntities.ANALYTICS} EMPTY_CART`,
    CHECKOUT_STEP: `${MiddlewareEntities.ANALYTICS} CHECKOUT_STEP`,
    SELECT_PAYMENT_OPTION: `${MiddlewareEntities.ANALYTICS} SELECT_PAYMENT_OPTION`,
    ADD_SHIPPING_INFO: `${MiddlewareEntities.ANALYTICS} ADD_SHIPPING_INFO`,
    SUBMIT_ORDER: `${MiddlewareEntities.ANALYTICS} SUBMIT_ORDER`,
    CANCEL_ORDER: `${MiddlewareEntities.ANALYTICS} CANCEL_ORDER`,
    PURCHASE: `${MiddlewareEntities.ANALYTICS} PURCHASE`,
    REFUND: `${MiddlewareEntities.ANALYTICS} REFUND`,
    VIEW_PROMOTION: `${MiddlewareEntities.ANALYTICS} VIEW_PROMOTION`,
    SELECT_PROMOTION: `${MiddlewareEntities.ANALYTICS} SELECT_PROMOTION`,
    SELECT_INSURANCE: `${MiddlewareEntities.ANALYTICS} SELECT_INSURANCE`,
    NEXT_CHECKOUT_STEP: `${MiddlewareEntities.ANALYTICS} NEXT_CHECKOUT_STEP`,
    TOPUP_STEP: `${MiddlewareEntities.ANALYTICS} TOPUP_STEP`,
    PPR_INTERACTION: `${MiddlewareEntities.ANALYTICS} PPR_INTERACTION`,
    CHOOSE_PACKAGE: `${MiddlewareEntities.ANALYTICS} CHOOSE_PACKAGE`,
    SUBMIT_CAMPAIGN_CHOICE: `${MiddlewareEntities.ANALYTICS} SUBMIT_CAMPAIGN_CHOICE`,
    CAMPAIGN_CONFIRMATION: `${MiddlewareEntities.ANALYTICS} CAMPAIGN_CONFIRMATION`,
    JUST_VIEW_CART: `${MiddlewareEntities.ANALYTICS} JUST_VIEW_CART`,
    CAMPAIGN_VIEW_CART: `${MiddlewareEntities.ANALYTICS} CAMPAIGN_VIEW_CART`,
    P2PDJ_STEP: `${MiddlewareEntities.ANALYTICS} P2PDJ_STEP`,
    P2PDJ_PURCHASE: `${MiddlewareEntities.ANALYTICS} P2PDJ_PURCHASE`,
    ORDER_CANCELED: `${MiddlewareEntities.ANALYTICS} ORDER_CANCELED`,
    ACESSORY_GO_TO_CHECKOUT: `${MiddlewareEntities.ANALYTICS} ACESSORY_GO_TO_CHECKOUT`,
  },
  DEBUG: {
    GET_DEBUG_INFO: `${MiddlewareEntities.DEBUG} GET_DEBUG_INFO`,
    SET_DEBUG_INFO: `${MiddlewareEntities.DEBUG} SET_DEBUG_INFO`,
    SET_MOCK_RESPONSE: `${MiddlewareEntities.DEBUG} SET_MOCK_RESPONSE`,
  }
};

export default ActionTypes;
